import { handleQueryError, isErrorResponse } from '../../app/notifications/ErrorNotification';
import { usePostDataQueryMutation } from '../api/dataQueryApi';
import { Environment, FinishedVehicleQueryResult, SelectedContext } from './dataQuery.types';
import { QueryFailedErrorResponseCodec } from '../api/errorCodecs';

export type DataQueryHookResult = {
    processQuery: (query: string, selectedContext: SelectedContext, environment: Environment) => Promise<void>;
    queryId: string | undefined;
    isProcessing: boolean;
    queryFailed: boolean;
    results: Omit<FinishedVehicleQueryResult, 'queryId'> | undefined;
};

const TABLE_DATA_QUERY_CACHE_KEY = 'OOB_INSPECTOR_TABLE_DATA_QUERY';

export const useTableDataQuery = (): DataQueryHookResult => {
    const [execute, { isLoading, data, error: mutationError }] = usePostDataQueryMutation({
        fixedCacheKey: TABLE_DATA_QUERY_CACHE_KEY,
    });

    const [queryId, queryFailed] = isErrorResponse(mutationError, QueryFailedErrorResponseCodec)
        ? [mutationError.data.query_id, true]
        : [data?.queryId, false];

    const processQuery = async (query: string, selectedContext: SelectedContext, environment: Environment) => {
        try {
            await execute({ query, selectedContext, environment }).unwrap();
        } catch (error) {
            if (!isErrorResponse(error, QueryFailedErrorResponseCodec)) {
                handleQueryError(error);
            }
        }
    };

    return { processQuery, queryId, isProcessing: isLoading, queryFailed, results: data };
};
